// extracted by mini-css-extract-plugin
export default {"textContainer":"main_textContainer__9u8MW","closeButton":"main_closeButton__zg75r","logoutButton":"main_logoutButton__WZedL","btnContainer":"main_btnContainer__Vg6Re"};